export default __webpack_public_path__ + "static/media/Vimeo.cfff6f0a.svg";